[{
    "policyVersions": [
        {
            "transactionType": "ADD",
            "productCode": "EC-TOURNAMENT",
            "insured": {
                "insuredName": "Indoor Hockey"
            },
            "insuredAddress": {
                "street": "80 Bent St.",
                "suiteOrUnit": "",
                "city": "Dover",
                "state": "DE",
                "zipCode": "19901",
                "country": "USA"
            },
            "policyEffectiveDate": "2021-01-21T00:00:00",
            "policyExpirationDate": "2021-03-27T00:01:00",
            "totalPremium": 492.00000,
            "covers": [
                {
                    "coverageCode": "GL",
                    "grossPremium": 492.00000,
                    "sumInsuredLimit": 80000.0,
                    "brokerNumber": "7930",
                    "carrierCode": "44000120",
                    "carrierPolicyNumber": "21HA000266"
                },
                {
                    "coverageCode": "TRIA",
                    "grossPremium": 5.00000,
                    "sumInsuredLimit": 80000.0,
                    "brokerNumber": "7930",
                    "carrierCode": "44000120",
                    "carrierPolicyNumber": "21HA000266"
                }
            ],
            "events": [
                {
                    "eventName": "Hockey Tournament",
                    "eventStartDate": "2021-03-23T00:00:00",
                    "eventEndDate": "2021-03-27T00:01:00",
                    "eventNumber": 1,
                    "pmlCategory": 2,
                    "eventType": "HOCKEY",
                    "aggregateLimit": 80000.0,
                    "venueName": "Dover Ice Arena",
                    "venueAddress1": "110 Portland Ave",
                    "venueAddress2": "",
                    "venueCity": "Dover",
                    "venueState": "NH",
                    "venuePostalCode": "03820",
                    "venueCountry": "US"
                }
            ]
        },
        {
            "transactionType": "ADD",
            "productCode": "EC-TOURNAMENT",
            "insured": {
                "insuredName": "kevin"
            },
            "insuredAddress": {
                "street": "1 st",
                "suiteOrUnit": "",
                "city": "Dover",
                "state": "DE",
                "zipCode": "19901",
                "country": "USA"
            },
            "policyEffectiveDate": "2021-01-21T00:00:00",
            "policyExpirationDate": "2021-03-01T00:01:00",
            "totalPremium": 1730.00000,
            "covers": [
                {
                    "coverageCode": "GL",
                    "grossPremium": 1730.00000,
                    "sumInsuredLimit": 200000.0,
                    "brokerNumber": "7930",
                    "carrierCode": "44000120",
                    "carrierPolicyNumber": "21HA000267"
                },
                {
                    "coverageCode": "TRIA",
                    "grossPremium": 18.00000,
                    "sumInsuredLimit": 200000.0,
                    "brokerNumber": "7930",
                    "carrierCode": "44000120",
                    "carrierPolicyNumber": "21HA000267"
                }
            ],
            "events": [
                {
                    "eventName": "DE game",
                    "eventStartDate": "2021-02-28T00:00:00",
                    "eventEndDate": "2021-03-01T00:01:00",
                    "eventNumber": 1,
                    "pmlCategory": 2,
                    "eventType": "BASKETBALL",
                    "aggregateLimit": 200000.0,
                    "venueName": "DE palace",
                    "venueAddress1": "1 st",
                    "venueAddress2": "",
                    "venueCity": "Dover",
                    "venueState": "DE",
                    "venuePostalCode": "19901",
                    "venueCountry": "US"
                }
            ]
        }
    ]
}
]